<mat-nav-list>
  <mat-list-item *ngFor="let link of links;">
     <button routerLink="{{link.target}}" mat-icon-button mat-list-avatar>
        <mat-icon color="primary" style="font-size:24px">{{link.icon}}</mat-icon>
     </button>
     <a mat-line routerLink="{{link.target}}" style="font-size:1em">{{link.description}}</a>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item (click)="logOut()">
     <button mat-icon-button mat-list-avatar>
        <mat-icon color="primary" style="font-size:24px">cancel</mat-icon>
     </button>
     <a mat-line>Sortir</a>
  </mat-list-item>
</mat-nav-list>
